const CONSTANTS = {
  SOCIAL: {
    FACEBOOK: 'https://www.facebook.com/pihhhhh',
    LINKEDIN: 'https://www.linkedin.com/in/filipe-mota-de-s%C3%A1-257639134/'
  },
  FIREBASE: {
    apiKey: 'AIzaSyCGSj1ZOt1YuA0EJ_TtqSn9J-a6xklUQoA',
    authDomain: 'portfolio-8bb32.firebaseapp.com',
    databaseURL: 'https://portfolio-8bb32.firebaseio.com',
    projectId: 'portfolio-8bb32',
    storageBucket: '',
    messagingSenderId: '757005383282'
  },
  ELLIPSIS: {
    LIMIT: 25
  }
};


export default CONSTANTS;
